module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhBAMAAAClyt9cAAAAG1BMVEUAAAAkJiYkJiYkJiYkJiYkJiYkJiYkJiYkJiYLY0YnAAAACHRSTlMAwPPGIrwgH1Ba8nAAAAA8SURBVCjPY4ACR1UHBlRg0WGAJtLR0TC8RAo7UEBjAkNEByoQYNBAE1HAVINpzqDzKaUiBNOGoyIs/QAAkYJTLWppCdsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_black/plus.png
// module id = VRHR
// module chunks = 1